/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileRequest } from '../../models/profile-request';
import { ProfileResponse } from '../../models/profile-response';

export interface CreateProfile$Params {

/**
 * is Profile private.
 */
  isPrivate?: boolean;

/**
 * campaign, such as slsp
 */
  campaign?: string;
  
    /**
     * New profile.
     */
    body: ProfileRequest
}

export function createProfile(http: HttpClient, rootUrl: string, params: CreateProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileResponse>> {
  const rb = new RequestBuilder(rootUrl, createProfile.PATH, 'post');
  if (params) {
    rb.query('isPrivate', params.isPrivate, {});
    rb.query('campaign', params.campaign, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProfileResponse>;
    })
  );
}

createProfile.PATH = '/rest/profile';
